import { languageConfig } from "~/config/language.config";

export const cleanStringsConcat = (strings) => {
  return strings
    .join(" ")
    .replace(/ +(?= )/g, "")
    .trim();
};

export const getFullName = (name) => {
  return cleanStringsConcat([
    name.lastName,
    name.firstName,
    name.middleName ? name.middleName : "",
  ]);
};

export const unlocalizeRouteName = (routeName) =>
  routeName.replace(/^[a-z]+_/, "");

export const unlocalizeUrl = (url) => {
  const locales = languageConfig.map(({ synonym }) => synonym);
  const regexp = new RegExp(`^/(${locales.join("|")})(/|$)`);

  return url.replace(regexp, "/");
};

export const urlify = (text) => {
  const urlRegex =
    /\b((?:https?|ftp):\/\/[^\s/$.?#].[^\s]*|www\.[^\s/$.?#].[^\s]*)\b/gi;

  // заменяем переносы строк на <br>
  const withLineBreak = text.replace(/\r\n|\r|\n/g, " <br> ");

  return withLineBreak.replace(urlRegex, (url) => {
    // Если строка не начинается с http:// или https:// → добавляем https://
    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    return `<a href="${href}" target="_blank" style="word-break: break-word">${url}</a>`;
  });
};

export const isYoutubeUrl = (url) => {
  const youtubeRegex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/g;

  return youtubeRegex.test(url);
};

export const getYoutubeVideoId = (videoUrl) => {
  const url = new URL(videoUrl);

  //example https://www.youtube.com/watch?v=qQmEGSFKB-8
  if (url.pathname === "/watch") {
    return url.searchParams.get("v");
  }

  //example https://www.youtube.com/embed/qQmEGSFKB-8
  //example https://youtu.be/qQmEGSFKB-8
  return url.pathname.split("/").pop();
};
